export const PAYROLL_DATA = "payroll_data"; 
export const PAYROLL_DATA_SUCCESSFULL = "payroll_data_successfull";
export const ADD_ATTENDENCE = "add_attendence";
export const ADD_ATTENDENCE_SUCCESSFULL = "add_attendence_successfull";
export const CREATE_PAY_ROLL_DATA = "create_payroll_data";
export const CREATE_PAY_ROLL_DATA_SUCCESSFULL = "create_payroll_data";
export const PAYROLL_CREATE  = "payroll_create" ;
export const PAYROLE_CREATE_SUCCESS  = "payroll_create_success";